/**
 * Raised by the app's fetch transport when the server responds with a body that
 * is not the API's JSON envelope — typically an infrastructure-level rejection
 * (nginx / Kestrel HTML error page) such as 413 Content Too Large or a 502.
 *
 * Without this, `response.json()` throws a raw `SyntaxError`
 * ("Unexpected token '<'") that the API error handler cannot classify, so the
 * user sees a generic "unexpected error". Carrying the HTTP status lets callers
 * branch on it (e.g. show a friendly "file too large" message on uploads).
 */
export class HttpTransportError extends Error {
    constructor(
        public readonly status: number,
        message?: string,
    ) {
        super(message ?? `Request failed with HTTP ${status}`);
        this.name = 'HttpTransportError';
    }
}
